import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { appStatus } from "../../store/modules/app_status/actions";
import { canEditUserRecord } from "../../utils/userRoles";

import {
  StyledTable as Table,
  StyledTableHead as THead,
  StyledTableRow as TR,
  StyledTableHeader as TH,
  StyledTableCell as TD,
  StyledButtonVisualizar,
  HoverTR,
  Container,
  DesktopOnly,
  MobileCards,
  MobileCard,
  MobileCardTitle,
  MobileCardMeta,
  MobileCardActions,
  ActionsCell,
} from "./styles";

const UsersTable = ({ filteredUsers }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);

  const rows = Array.isArray(filteredUsers) ? filteredUsers : [];
  const showAnyEdit = rows.some((row) => canEditUserRecord(currentUser, row));

  const handleGoToEditUser = (user) => {
    if (!canEditUserRecord(currentUser, user)) return;
    dispatch(appStatus("edit_user"));
    navigate("/welcome", { state: { user } });
  };

  return (
    <Container>
      <DesktopOnly>
        <Table>
          <THead>
            <TR>
              <TH>Nome</TH>
              <TH>E-mail</TH>
              <TH>Whatsapp</TH>
              <TH>Localidade</TH>
              <TH>Acesso</TH>
              {showAnyEdit ? <TH>Ação</TH> : null}
            </TR>
          </THead>
          <tbody>
            {rows.map((row, index) => {
              const canEdit = canEditUserRecord(currentUser, row);
              return (
                <HoverTR key={row.id || index} className="hover">
                  <TD>{row.full_name}</TD>
                  <TD>{row.email}</TD>
                  <TD>{row.phone}</TD>
                  <TD>
                    {row.city}, {row.state}
                  </TD>
                  <TD>{row.user_type}</TD>
                  {showAnyEdit ? (
                    <TD>
                      {canEdit ? (
                        <ActionsCell>
                          <StyledButtonVisualizar
                            type="button"
                            onClick={() => handleGoToEditUser(row)}
                          >
                            Editar
                          </StyledButtonVisualizar>
                        </ActionsCell>
                      ) : null}
                    </TD>
                  ) : null}
                </HoverTR>
              );
            })}
          </tbody>
        </Table>
      </DesktopOnly>

      <MobileCards>
        {rows.map((row, index) => {
          const canEdit = canEditUserRecord(currentUser, row);
          return (
            <MobileCard key={`m-${row.id || index}`}>
              <MobileCardTitle>{row.full_name}</MobileCardTitle>
              <MobileCardMeta>{row.email}</MobileCardMeta>
              <MobileCardMeta>{row.phone || "—"}</MobileCardMeta>
              <MobileCardMeta>
                {row.city}, {row.state}
              </MobileCardMeta>
              <MobileCardMeta>Acesso: {row.user_type}</MobileCardMeta>
              {canEdit ? (
                <MobileCardActions>
                  <StyledButtonVisualizar
                    type="button"
                    onClick={() => handleGoToEditUser(row)}
                  >
                    Editar
                  </StyledButtonVisualizar>
                </MobileCardActions>
              ) : null}
            </MobileCard>
          );
        })}
      </MobileCards>
    </Container>
  );
};

export default UsersTable;
